// import { _getCookie } from '../../Cookies/functions/_getCookie';
// import { _setCookie } from '../../Cookies/functions/_setCookie';
// import { _jumbleLogo } from '../../SiteHeader/functions/_jumbleLogo';

export const _handle = () => {
	// Get all the needed elements.
	const transition = document.querySelector( '[data-page-transition]' );
	const anchors = document.querySelectorAll( 'a' );

	// Return if no transition could be found.
	if ( ! transition ) {
		return;
	}

	hideTransition( transition, () => {
		document.body.classList.add( 'transition-ready' );
	} );

	anchors.forEach( ( link ) =>
		link.addEventListener( 'click', ( event ) => {
			if (
				( ! link.href || link.href.includes( '#' ) || link.hostname !== window.location.hostname || link.getAttribute( 'target' ) === '_blank' ) ||
				( event.metaKey || event.ctrlKey || link.closest( '#wpadminbar' ) !== null )
			) {
				return;
			}

			event.preventDefault();

			const homeURL = document.location.origin + '/';

			showTransition( transition, () => {
				if ( link.href === homeURL ) {
					document.body.classList.add( 'going-to-home' );
				} else {
					document.body.classList.add( 'going-to-page' );
				}

				setTimeout( () => {
					window.location.href = link.href;
				}, 7 );
			} );
		} )
	);
};

/**
 * This function hides the referenced transition-element.
 *
 * @param {Node} transition The transition element.
 * @param {Function} callback The callback function.
 */
const hideTransition = ( transition = null, callback = () => {} ) => {
	if ( transition ) {
		setTimeout( () => {
			document.body.classList.remove( 'transition-visible' );
			document.body.classList.add( 'transition-hide' );
			transition.setAttribute( 'data-page-transition', 'hide' );
		}, 0.25 * 1000 );

		// Safari back button
		window.addEventListener( 'pageshow', function( event ) {
			if ( ! event.persisted ) {
				return;
			}

			document.body.classList.remove( 'transition-visible' );
			document.body.classList.add( 'transition-hide' );
			transition.setAttribute( 'data-page-transition', 'hide' );
		} );

		const onTransitionEnd = () => {
			callback();
			transition.removeEventListener( 'transitionend', onTransitionEnd );
		};

		transition.addEventListener( 'transitionend', onTransitionEnd );
	}
};

/**
 * This function shows the referenced transition-element.
 *
 * @param {Node} transition The transition element.
 * @param {Function} callback The callback function.
 */
const showTransition = ( transition = null, callback = () => {} ) => {
	if ( transition ) {
		document.body.classList.add( 'transition-visible' );
		document.body.classList.add( 'transition-show' );
		transition.setAttribute( 'data-page-transition', 'show' );

		const onTransitionEnd = () => {
			callback();
			transition.removeEventListener( 'transitionend', onTransitionEnd );
		};

		transition.addEventListener( 'transitionend', onTransitionEnd );
	}
};
